import { BaseDiagnostic, DiagnosticSeverity } from "../../validation-service";

export interface IErrorInformative {
  get issueCount(): number;
  get severityColor(): string;
  setValue(array: BaseDiagnostic[]): void;
}

export class DiagnosticsErrorInformation implements IErrorInformative {
  diagnostics: BaseDiagnostic[];

  constructor(diagnostics: BaseDiagnostic[]) {
    this.diagnostics = diagnostics;
  }

  setValue(array: BaseDiagnostic[]) {
    this.diagnostics = array;
  }

  get issueCount(): number {
    return this.diagnostics.length;
  }
  get severityColor(): string {
    return this.errors > 0 ? "error" : "warning";
  }

  private get errors(): number {
    return this.diagnostics.filter((d) => d.severity === DiagnosticSeverity.ERROR).length;
  }

  private get warnings(): number {
    return this.diagnostics.filter((d) => d.severity === DiagnosticSeverity.WARNING).length;
  }
}
